




















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'lb-link'
})
export default class extends Vue {
  @Prop({ default: 'default' }) private type!: string;
  @Prop({ type: Boolean, default: true }) private underline!: boolean;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  @Prop() private href!: string;
  @Prop() private icon!: string;

  private handleClick(event: any) {
    if (!this.disabled) {
      if (!this.href) {
        this.$emit('click', event);
      }
    }
  }
}
